<template>
  <div class="charts__wrapper">
    <h1 class="charts__head">
      <SfButton :disabled="!canPrevMonth" @click="getPrevMonth">Прошлый месяц</SfButton>
      Статистика за: {{ month }} 2021
      <SfButton :disabled="!canNextMonth" @click="getNextMonth">Следующий месяц</SfButton>
    </h1>
    <div class="charts">
      <div class="small">
        <h3>Посещения</h3>
        <bar-chart :chart-data="datacollection1"></bar-chart>
        <p>
          <strong>Общие</strong> - сколько раз в сумме все клиенты посетили ваши товары магазина
          <br>
          <strong>Уникальных клиентов</strong> (неповторяющийся пользователь) - сумма всех уникальных пользователей, которые ваши товары магазина
        </p>
      </div>
      <div class="small">
        <h3>Просмотры</h3>
        <bar-chart :chart-data="datacollection2"></bar-chart>
        <p>
          <strong>Магазина</strong> - сколько раз просмотрели магазин (через каталог магазинов)
          <br>
          <strong>Товаров</strong> - сколько раз просмотрели товары магазина (через каталог общий и каталог магазина)
        </p>
      </div> 
      <div class="small">
        <h3>Действия</h3>
        <bar-chart :chart-data="datacollection3"></bar-chart>
        <p>
          <strong>Позвонили</strong> - сколько раз нажали на кнопку - позвонить / посмотреть номер
          <br>
          <strong>Написали</strong> - сколько раз нажали на кнопку - написать
        </p>
      </div> 
    </div>
    <div class="dashboard-title">
      <h1>Самые популярные товары</h1>
      <SfSelect label="Отображать по:" valid :value="String(productsCount)" style="width: 150px" @input="changeCount">
        <SfSelectOption value="5">
          5
        </SfSelectOption>
        <SfSelectOption value="10">
          10
        </SfSelectOption>
        <SfSelectOption value="20">
          20
        </SfSelectOption>
        <SfSelectOption value="30">
          30
        </SfSelectOption>
        <SfSelectOption value="50">
          50
        </SfSelectOption>
      </SfSelect>
    </div>
    
    <SfTable>
      <SfTableHeading>
        <SfTableHeader>Название</SfTableHeader>
        <SfTableHeader>Цена</SfTableHeader>
        <SfTableHeader>Просмотров</SfTableHeader>
        <SfTableHeader>
          <SfButton class="sf-button--text">Действия</SfButton>
        </SfTableHeader>
      </SfTableHeading>
      <SfTableRow v-for="product in sortedProducts" :key="product.id">
        <SfTableData>{{ product.name }}</SfTableData>
        <SfTableData>{{ product.price }}</SfTableData>
        <SfTableData>{{ product.view }}</SfTableData>
        <SfTableData>
          <router-link :to="{ name: 'product', params: { slug: product.slug } }">
            <SfButton class="sf-button--text">Перейти</SfButton>
          </router-link>
        </SfTableData>
      </SfTableRow>
    </SfTable>
    <h1>Самые популярные категории</h1>
    <SfTable>
      <SfTableHeading>
        <SfTableHeader>Название</SfTableHeader>
        <SfTableHeader>Просмотры</SfTableHeader>
      </SfTableHeading>
      <SfTableRow v-for="category in sortedCategories" :key="category.id">
        <SfTableData>{{ category.category.name }}</SfTableData>
        <SfTableData>{{ category.visits_total || 0 }}</SfTableData>
      </SfTableRow>
    </SfTable>

    <h1>Среднее время просмотра</h1>

    <SfTable>
      <SfTableHeading>
        <SfTableHeader>Общее</SfTableHeader>
        <SfTableHeader>Товары</SfTableHeader>
        <SfTableHeader>Магазины</SfTableHeader>
      </SfTableHeading>
      <SfTableRow>
        <SfTableData>16 минут 02 секунд</SfTableData>
        <SfTableData>11 минут 23 секунд</SfTableData>
        <SfTableData>4 минут 39 секунд</SfTableData>
      </SfTableRow>
    </SfTable>

    <p>
      <strong>Общее</strong> - сумма среднего просмотра и товаров и магазинов
      <br>
      <strong>Товары</strong> - сколько в среднем находятся на странице одного товара
      <br>
      <strong>Магазины</strong> - сколько в среднем находятся на странице одного магазина
    </p>

  </div>
  
</template>

<script>
import apiRequest from '../../shared/apiRequest'
import BarChart from '../charts/BarChart'

import moment from 'moment'

import { SfButton, SfTable, SfSelect } from '@storefront-ui/vue'

  export default {
    props: {
    account: {
      type: Object,
      default: () => ({}),
    },
  },
    components: {
      BarChart,
      SfButton, SfTable, SfSelect
    },
    data () {
      return {
        datacollection1: null,
        datacollection2: null,
        datacollection3: null,
        products: [],
        productsCount: 5,
        categories: [],
        shop: {},
        analytics: {},
        currentMonth: moment().month() + 1
      }
    },
    mounted () {
      this.getProducts()
      this.getShopInfo()
    },
    methods: {
      changeCount(v) {
        console.log(v)
        this.productsCount = v;
      },
      getPrevMonth() {
        this.currentMonth--;
        this.getShopInfo()
      },
      getNextMonth() {
        this.currentMonth++;
        this.getShopInfo()
      },
      fillData () {
        const { 
          visits_total, visits_unique, 
          views_shop, views_products,
          actions_call, actions_write
        } = this.analytics

        this.datacollection1 = {
          labels: ['Общие', 'Уникальных клиентов'],
          datasets: [
            {
              backgroundColor: ['#f5b800', '#f8f979'],
              data: [visits_total, visits_unique]
            }
          ]
        }
        this.datacollection2 = {
          labels: ['Магазина', 'Товаров'],
          datasets: [
            {
              backgroundColor: ['#f5b800', '#f8f979'],
              data: [views_shop, views_products]
            }
          ]
        }
        this.datacollection3 = {
          labels: ['Позвонили', 'Написали'],
          datasets: [
            {
              backgroundColor: ['#f5b800', '#f8f979'],
              data: [actions_call, actions_write]
            }
          ]
        }
      },
      getProducts() {
        const data = {};

        data.page = 1
        data.perPage = 1000

        apiRequest.get(`/users/${this.account.id}/shop/products`, {
          params: data
        })
            .then((result) => {
              const { data } = result.data;
              this.products = data;
            })
            .catch((error) => {
              console.log(error)
            });
      },
      getCategories() {
        apiRequest.get(`/category_analytics/${this.shop.id}`)
            .then(({ data }) => {
              this.categories = data;
            })
            .catch((error) => {
              console.log(error)
            });
      },
      getShopInfo() {
        apiRequest.get(`/users/${this.account.id}/shop`)
          .then((result) => {
            this.shop = result.data
            this.getAnalytics()
            this.getCategories()
          })
      },
      getAnalytics() {
        apiRequest.get(`/analytics/${this.shop.id}`, {
          params: {
            month: this.currentMonth
          }
        })
            .then(({ data }) => {
              this.analytics = data
              this.fillData()
            })
            .catch((error) => {
              console.log(error)
            });
      },
      getRandomInt () {
        return Math.floor(Math.random() * (50 - 5 + 1)) + 5
      }
    },
    computed: {
      canNextMonth() {
        return !moment().month(this.currentMonth - 1).isSameOrAfter(moment())
      },
      canPrevMonth() {
        return !(this.currentMonth - 1 <= 4)
      },
      sortedCategories() {
        const categories = this.categories
        return categories.sort((a, b) => {
          if (a.views > b.views) {
            return -1;
          }
          if (a.views < b.views) {
            return 1;
          }
          // a должно быть равным b
          return 0;
        })
      },
      sortedProducts() {
        const products = this.products
        return products.sort((a, b) => {
          if (a.view > b.view) {
            return -1;
          }
          if (a.view < b.view) {
            return 1;
          }
          // a должно быть равным b
          return 0;
        }).slice(0, this.productsCount)
      },
      month() {
        const month = moment().month(this.currentMonth - 1).locale('ru').format('MMMM')
        return month.charAt(0).toUpperCase() + month.slice(1)
      }
    }
  }
</script>

<style lang="scss">
  .charts {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    flex-wrap: wrap;

    &__head {
      display: flex;
      width: 100%;
      align-items: center;
      justify-content: space-between;
    }
  }
  .small {
    flex: 1 0 33%;
    max-width: 33%;
    padding: 50px;
  }

  .dashboard-title {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }



@media all and (max-width: 768px) {
  .charts {
      flex-direction: column;
  }
  .charts > div {
      width: 100%;
      flex: 1 0 100%;
      max-width: 100%;
      padding: 0;
  }


  h1.charts__head {
      flex-direction: column;
  }

  h1.charts__head button {
      margin: 10px 0;
  }

  .charts__wrapper {
      padding: 0 20px;
  }
}
 
</style>